import { make } from 'vuex-pathify'
import countries from 'i18n-iso-countries'
import de from 'i18n-iso-countries/langs/de.json'
import en from 'i18n-iso-countries/langs/en.json'

const regulatedSepaCodes = ['AD', 'FR', 'GI', 'GB', 'MC', 'SM']

const sepaCountryCodes = [
  'AD',
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GI',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'SM'
]

const availableLocales = ['de', 'en']

const state = {
  regulatedSepaCodes: regulatedSepaCodes,
  countries: {
    en: [],
    de: []
  }
}

const getters = {
  ...make.getters(state)
}

const createListOfNames = (locale) => {
  const list = []
  const names = countries.getNames(locale, { select: 'official' })
  const keys = Object.keys(names)
  for (const k of keys) {
    if (sepaCountryCodes.includes(k)) {
      list.push({ code: k, value: names[k] })
    }
  }
  return list
}

const updateCountries = async () => {
  countries.registerLocale(en)
  countries.registerLocale(de)

  for (const locale of availableLocales) {
    state.countries = Object.assign(state.countries, {
      [locale]: createListOfNames(locale).map((entry) => {
        return { value: entry.code, label: entry.value }
      })
    })
  }
}

updateCountries()

export default {
  namespaced: true,
  state,
  getters
}
